<template>
    <v-menu
      v-if="value"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formattedDate"
          :label="label"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        first-day-of-week="1"
        locale="no"
        v-model="value.value"
        @input="menu2 = false"
        @change="formatDate"
      ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      menu: false,
      menu2: false,
      formattedDate: ""
    };
  },
  activated: function() {
    this.formatDate();
  },
  methods: {
    formatDate() {
      if (this.value) {
        if(this.value.value) {
          const [year, month, day] = this.value.value.split("-");
          this.formattedDate = `${day}.${month}.${year}`;
        }
      }
    }
  }
};
</script>